import { Gender, ManagementPosition } from '@xendit/id-open-banking-ekyb-common/dist/enums/submission';
import { GenderMap, ManagementPositionMap } from 'helpers/utils/enumsNameMappings';
import { FormBuilderField } from 'types/form.type';

export const Form2Section2Fields = (index = 0): FormBuilderField[] => [
  {
    name: `entity.managements[${index}].name`,
    label: 'Nama Lengkap (menurut dokumen identitas)',
    type: 'text',
    placeholder: 'Nama',
    fullWidth: true,
    validation: {
      required: 'Nama harus diisi'
    }
  },
  {
    name: `entity.managements[${index}].gender`,
    label: 'Jenis Kelamin',
    type: 'radio',
    fullWidth: true,
    options: Object.keys(Gender).map((item) => {
      return { label: GenderMap[item as Gender], value: item, key: item };
    }),
    validation: {
      required: 'Jenis Kelamin harus diisi'
    }
  },
  {
    name: `entity.managements[${index}].position`,
    label: 'Jabatan',
    type: 'autocomplete',
    defaultValue: '',
    options: Object.keys(ManagementPosition).map((item) => {
      return { label: ManagementPositionMap[item as ManagementPosition], value: item, key: item };
    }),
    placeholder: 'Pilih',
    validation: {
      required: 'Jabatan harus diisi'
    }
  },
  {
    name: `entity.managements[${index}].email_address`,
    label: 'Alamat Email',
    type: 'text',
    placeholder: 'Alamat Email',
    fullWidth: true,
    validation: {
      required: 'Alamat Email harus diisi',
      pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: 'Berikan alamat email yang valid'
      }
    }
  },
  {
    name: `entity.managements[${index}].phone_number`,
    label: 'Nomor Handphone',
    placeholder: '0000',
    type: 'phonenumber',
    validation: {
      required: 'Nomor Handphone harus diisi',
      validate: {
        isEmpty: (value) => !!value.slice(3) || 'Nomor Handphone harus diisi',
        isNumber: (value: string) => !isNaN(Number(value)) || 'Pastikan format nomor sesuai',
        isPositive: (value) => Number(value) > 0 || 'Pastikan format nomor sesuai'
      }
    }
  },
  {
    name: 'identityDocument',
    label: 'Dokumen Identitas (KTP)',
    type: 'group',
    children: [
      {
        name: `entity.managements[${index}].identity_number`,
        label: 'Nomor Identitas',
        placeholder: 'Nomor',
        type: 'text',
        fullWidth: true,
        span: 9,
        validation: {
          required: 'Nomor Identitas harus diisi',
          validate: {
            isNumber: (value: string) => !isNaN(Number(value)) || 'Pastikan format nomor sesuai',
            isPositive: (value) => Number(value) > 0 || 'Pastikan format nomor sesuai'
          }
        }
      },
      {
        name: `entity.managements[${index}].identity_document_id`,
        type: 'file',
        label: 'Dokumen Identitas',
        fullWidth: true,
        span: 9,
        validation: {
          required: 'Dokumen Identitas harus diisi'
        }
      }
    ]
  },
  {
    type: 'divider'
  }
];
